import React from 'react';
import PropTypes from 'prop-types';

import { PartenaireCard } from './';

const Partenaire = ({ title, list, listIcon, children }) => {
  return (
    <div style={{ backgroundColor: '#f5f5f5' }}>
      <div style={{ padding: '30px 0 30px 0' }} className="container">
        <center>
          <h3 style={{ fontWeight: 'bold', marginBottom: 20 }}>{title}</h3>
        </center>
      </div>
      <div className="row" style={{ marginLeft: 0, marginRight: 0 }}>
        {list.map((item, i) => {
          let color;
          switch (i) {
            case 0:
              color = '#085170';
              break;
            case 1:
              color = '#2A8FBA';
              break;
            case 2:
              color = '#1EA8E2';
              break;
            default:
              break;
          }

          return (
            <div
              key={item}
              className="col-md"
              style={{ paddingLeft: 0, paddingRight: 0 }}
            >
              <PartenaireCard title={item} icon={listIcon[i]} color={color} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

Partenaire.propTypes = {
  title: PropTypes.string.isRequired,
  list: PropTypes.array.isRequired,
  listIcon: PropTypes.array.isRequired,
};

export default Partenaire;



// WEBPACK FOOTER //
// ./src/components/Main/brand/Partenaire.js